import React, { FC, ReactElement, ReactNode } from "react";
import { 
  Box, 
  // Paper, 
  useTheme
} from "@mui/material";
import { Title } from "./Title";
import { NotificationBar } from "./NotificationBar";

interface ContentProps {
    children: ReactNode;
}

export const Content: FC<ContentProps> = ({ children }): ReactElement => {
  const theme = useTheme();
  const mnuHeaderHeight = 70
  // document.getElementById("sidebarMnuHeader")?.clientHeight
  const footerHeight = 20
  // document.getElementById("footer")?.clientHeight
  const height: string = 
    'calc(100% - ' 
    + (mnuHeaderHeight? mnuHeaderHeight : 0 + (footerHeight? footerHeight : 0)).toString() 
    + ')'
  return (
    <React.Fragment>
      <Box
        sx={{
            minHeight: height,
            maxWidth: "100vw",
            mb:2,
            flexGrow: 1,
            backgroundColor: theme.palette.background.paper,
            // 'whitesmoke',
            fontFamily:'B Nazanin',
            // border: '1px solid #000'
        }}
      >
        <Title/>
        <NotificationBar/>
        <Box
          sx={{
            display:'flex',
            justifyContent:'center',
            mt:1,
            mx:'auto', 
            px:.8,
            py:.5,
            // height:'100%', 
            width:{xs:'98%', sm:'96%', md:'95%', lg:'94%', xl:'94%'}, 
            // boxShadow:.5,
            backgroundColor:'inherit',
            // border: '1px solid #000'
          }}
        >
          {children}
        </Box>
      </Box>
    </React.Fragment>
  )
}

